/**
 * YOBY accessibility widget — preferences via html.yoby-a11y-* + localStorage.
 * Shortcut: Alt+Shift+A (Win/Linux) / Option+Shift+A (macOS).
 */
(function () {
    'use strict';

    var MESSAGES = {
    "it": {
        "ui": [
            "Accessibilità",
            "Le preferenze si applicano subito alla pagina e restano salvate in questo browser.",
            "Apri questo pannello",
            "Chiudi",
            "Salta al contenuto",
            "Primo Tab → link «Vai al contenuto»",
            "Preferenze di visualizzazione",
            "Guida accessibilità completa",
            "Ripristina predefiniti",
            "Preferenze attive: ",
            "Preferenze predefinite",
            "Grande",
            "Extra grande",
            "Normale",
            "Attivo",
            "Off",
            "Vai al contenuto",
            "Usa Tab e Shift+Tab per spostarti tra i controlli, Invio o Spazio per attivarli. Le impostazioni riguardano le pagine del sito YOBY in questo browser. Ripristina predefiniti annulla tutte le preferenze."
        ],
        "options": [
            [
                "Contrasto elevato",
                "Migliora la leggibilità di testi e controlli"
            ],
            [
                "Inverti colori",
                "Scambia sfondo e testo su tutta la pagina"
            ],
            [
                "Testo più grande",
                "Cicla: normale → grande → extra grande"
            ],
            [
                "Spaziatura testo",
                "Interlinea e spaziatura tra lettere aumentate"
            ],
            [
                "Evidenzia focus",
                "Contorno più visibile su tastiera"
            ],
            [
                "Sottolinea link",
                "I link non dipendono solo dal colore"
            ],
            [
                "Riduci animazioni",
                "Disattiva transizioni e animazioni"
            ],
            [
                "Font leggibile",
                "Sans-serif di sistema"
            ]
        ]
    },
    "en": {
        "ui": [
            "Accessibility",
            "Preferences apply immediately to this page and are saved in this browser.",
            "Open this panel",
            "Close",
            "Skip to content",
            "First Tab → “Skip to content” link",
            "Display preferences",
            "Full accessibility guide",
            "Reset to defaults",
            "Active preferences: ",
            "Default preferences",
            "Large",
            "Extra large",
            "Normal",
            "On",
            "Off",
            "Skip to content",
            "Use Tab and Shift+Tab to move between controls, Enter or Space to activate them. Settings apply to YOBY website pages in this browser. Reset to defaults clears all preferences."
        ],
        "options": [
            [
                "High contrast",
                "Improve readability of text and controls"
            ],
            [
                "Invert colors",
                "Invert background and text across the page"
            ],
            [
                "Larger text",
                "Cycle: normal → large → extra large"
            ],
            [
                "Text spacing",
                "Increase line height and letter spacing"
            ],
            [
                "Highlight focus",
                "Stronger outline for keyboard navigation"
            ],
            [
                "Underline links",
                "Identify links beyond color alone"
            ],
            [
                "Reduce motion",
                "Disable transitions and animations"
            ],
            [
                "Readable font",
                "System sans-serif font"
            ]
        ]
    },
    "fr": {
        "ui": [
            "Accessibilité",
            "Les préférences s’appliquent immédiatement à la page et sont enregistrées dans ce navigateur.",
            "Ouvrir ce panneau",
            "Fermer",
            "Aller au contenu",
            "Premier Tab → lien « Aller au contenu »",
            "Préférences d’affichage",
            "Guide complet d’accessibilité",
            "Rétablir les valeurs par défaut",
            "Préférences actives : ",
            "Préférences par défaut",
            "Grand",
            "Très grand",
            "Normal",
            "Activé",
            "Désactivé",
            "Aller au contenu",
            "Utilisez Tab et Maj+Tab pour parcourir les commandes, Entrée ou Espace pour les activer. Les réglages s’appliquent aux pages du site YOBY dans ce navigateur. Le bouton de réinitialisation annule toutes les préférences."
        ],
        "options": [
            [
                "Contraste élevé",
                "Améliore la lisibilité des textes et commandes"
            ],
            [
                "Inverser les couleurs",
                "Inverse le fond et le texte de la page"
            ],
            [
                "Texte agrandi",
                "Cycle : normal → grand → très grand"
            ],
            [
                "Espacement du texte",
                "Augmente l’interligne et l’espacement des lettres"
            ],
            [
                "Renforcer le focus",
                "Contour plus visible au clavier"
            ],
            [
                "Souligner les liens",
                "Repérer les liens autrement que par la couleur"
            ],
            [
                "Réduire les animations",
                "Désactive transitions et animations"
            ],
            [
                "Police lisible",
                "Police sans empattement du système"
            ]
        ]
    },
    "es": {
        "ui": [
            "Accesibilidad",
            "Las preferencias se aplican inmediatamente a la página y se guardan en este navegador.",
            "Abrir este panel",
            "Cerrar",
            "Saltar al contenido",
            "Primer Tab → enlace «Saltar al contenido»",
            "Preferencias de visualización",
            "Guía completa de accesibilidad",
            "Restablecer valores predeterminados",
            "Preferencias activas: ",
            "Preferencias predeterminadas",
            "Grande",
            "Extra grande",
            "Normal",
            "Activado",
            "Desactivado",
            "Saltar al contenido",
            "Usa Tab y Mayús+Tab para recorrer los controles, Intro o Espacio para activarlos. Los ajustes se aplican a las páginas del sitio YOBY en este navegador. Restablecer anula todas las preferencias."
        ],
        "options": [
            [
                "Alto contraste",
                "Mejora la legibilidad de textos y controles"
            ],
            [
                "Invertir colores",
                "Invierte el fondo y el texto de toda la página"
            ],
            [
                "Texto más grande",
                "Ciclo: normal → grande → extra grande"
            ],
            [
                "Espaciado del texto",
                "Aumenta el interlineado y el espacio entre letras"
            ],
            [
                "Resaltar foco",
                "Contorno más visible al usar el teclado"
            ],
            [
                "Subrayar enlaces",
                "Identifica los enlaces más allá del color"
            ],
            [
                "Reducir movimiento",
                "Desactiva transiciones y animaciones"
            ],
            [
                "Fuente legible",
                "Fuente sans serif del sistema"
            ]
        ]
    },
    "pt": {
        "ui": [
            "Acessibilidade",
            "As preferências aplicam-se imediatamente à página e ficam guardadas neste navegador.",
            "Abrir este painel",
            "Fechar",
            "Saltar para o conteúdo",
            "Primeiro Tab → ligação «Saltar para o conteúdo»",
            "Preferências de visualização",
            "Guia completo de acessibilidade",
            "Repor predefinições",
            "Preferências ativas: ",
            "Preferências predefinidas",
            "Grande",
            "Extra grande",
            "Normal",
            "Ativo",
            "Desativado",
            "Saltar para o conteúdo",
            "Usa Tab e Shift+Tab para percorrer os controlos, Enter ou Espaço para os ativar. As definições aplicam-se às páginas do site YOBY neste navegador. Repor predefinições anula todas as preferências."
        ],
        "options": [
            [
                "Contraste elevado",
                "Melhora a legibilidade de textos e controlos"
            ],
            [
                "Inverter cores",
                "Inverte o fundo e o texto de toda a página"
            ],
            [
                "Texto maior",
                "Ciclo: normal → grande → extra grande"
            ],
            [
                "Espaçamento do texto",
                "Aumenta a entrelinha e o espaço entre letras"
            ],
            [
                "Realçar foco",
                "Contorno mais visível ao usar o teclado"
            ],
            [
                "Sublinhar ligações",
                "Identifica ligações para além da cor"
            ],
            [
                "Reduzir movimento",
                "Desativa transições e animações"
            ],
            [
                "Tipo de letra legível",
                "Tipo de letra sem serifa do sistema"
            ]
        ]
    },
    "de": {
        "ui": [
            "Barrierefreiheit",
            "Die Einstellungen gelten sofort für diese Seite und werden in diesem Browser gespeichert.",
            "Dieses Fenster öffnen",
            "Schließen",
            "Zum Inhalt springen",
            "Erster Tab → Link „Zum Inhalt springen“",
            "Anzeigeeinstellungen",
            "Vollständige Anleitung zur Barrierefreiheit",
            "Standardeinstellungen wiederherstellen",
            "Aktive Einstellungen: ",
            "Standardeinstellungen",
            "Groß",
            "Sehr groß",
            "Normal",
            "Ein",
            "Aus",
            "Zum Inhalt springen",
            "Mit Tab und Umschalt+Tab zwischen Bedienelementen wechseln, mit Eingabe oder Leertaste aktivieren. Die Einstellungen gelten für YOBY-Webseiten in diesem Browser. Zurücksetzen löscht alle Einstellungen."
        ],
        "options": [
            [
                "Hoher Kontrast",
                "Verbessert die Lesbarkeit von Text und Bedienelementen"
            ],
            [
                "Farben umkehren",
                "Kehrt Hintergrund und Text auf der Seite um"
            ],
            [
                "Größerer Text",
                "Wechsel: normal → groß → sehr groß"
            ],
            [
                "Textabstand",
                "Vergrößert Zeilen- und Buchstabenabstand"
            ],
            [
                "Fokus hervorheben",
                "Deutlichere Umrandung bei Tastaturbedienung"
            ],
            [
                "Links unterstreichen",
                "Links unabhängig von ihrer Farbe erkennen"
            ],
            [
                "Bewegung reduzieren",
                "Deaktiviert Übergänge und Animationen"
            ],
            [
                "Lesbare Schrift",
                "Serifenlose Systemschrift"
            ]
        ]
    },
    "nl": {
        "ui": [
            "Toegankelijkheid",
            "Voorkeuren worden meteen toegepast en in deze browser bewaard.",
            "Dit paneel openen",
            "Sluiten",
            "Naar de inhoud",
            "Eerste Tab → link ‘Naar de inhoud’",
            "Weergavevoorkeuren",
            "Volledige toegankelijkheidsgids",
            "Standaardinstellingen herstellen",
            "Actieve voorkeuren: ",
            "Standaardvoorkeuren",
            "Groot",
            "Extra groot",
            "Normaal",
            "Aan",
            "Uit",
            "Naar de inhoud",
            "Gebruik Tab en Shift+Tab om tussen bedieningselementen te bewegen, Enter of Spatie om ze te activeren. Instellingen gelden voor YOBY-webpagina’s in deze browser. Herstellen wist alle voorkeuren."
        ],
        "options": [
            [
                "Hoog contrast",
                "Verbetert de leesbaarheid van tekst en bediening"
            ],
            [
                "Kleuren omkeren",
                "Keert achtergrond en tekst op de pagina om"
            ],
            [
                "Grotere tekst",
                "Cyclus: normaal → groot → extra groot"
            ],
            [
                "Tekstafstand",
                "Vergroot regelhoogte en letterafstand"
            ],
            [
                "Focus markeren",
                "Duidelijkere omlijning bij toetsenbordgebruik"
            ],
            [
                "Links onderstrepen",
                "Herken links ook zonder kleur"
            ],
            [
                "Beweging verminderen",
                "Schakelt overgangen en animaties uit"
            ],
            [
                "Leesbaar lettertype",
                "Schreefloos systeemlettertype"
            ]
        ]
    }
};

    function messages() {
        return MESSAGES[document.documentElement.lang.split("-")[0]] || MESSAGES.en;
    }

    function t(index) { return messages().ui[index]; }

    var STORAGE_KEY = 'yoby-a11y-prefs';
    var modalEl = null;
    var prevFocus = null;
    var background = [];

    var DEFAULT_PREFS = {
        contrast: false,
        invertColors: false,
        textSize: 'normal',
        spacing: false,
        focusStrong: false,
        underlineLinks: false,
        reduceMotion: false,
        readableFont: false
    };

    var OPTIONS = [
        { key: 'contrast' },
        { key: 'invertColors' },
        { key: 'textSize', cycle: ['normal', 'lg', 'xl'] },
        { key: 'spacing' },
        { key: 'focusStrong' },
        { key: 'underlineLinks' },
        { key: 'reduceMotion' },
        { key: 'readableFont' }
    ];

    function loadPrefs() {
        try {
            var raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return Object.assign({}, DEFAULT_PREFS);
            var parsed = JSON.parse(raw);
            var prefs = Object.assign({}, DEFAULT_PREFS);
            Object.keys(DEFAULT_PREFS).forEach(function (key) {
                if (key === 'textSize') {
                    if (['normal', 'lg', 'xl'].indexOf(parsed && parsed[key]) >= 0) prefs[key] = parsed[key];
                } else if (parsed && typeof parsed[key] === 'boolean') prefs[key] = parsed[key];
            });
            return prefs;
        } catch (e) {
            return Object.assign({}, DEFAULT_PREFS);
        }
    }

    function savePrefs(prefs) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
        } catch (e) {}
    }

    function applyPrefs(prefs) {
        prefs = prefs || loadPrefs();
        var html = document.documentElement;

        html.classList.remove(
            'yoby-a11y-contrast',
            'yoby-a11y-invert-colors',
            'yoby-a11y-text-lg',
            'yoby-a11y-text-xl',
            'yoby-a11y-spacing',
            'yoby-a11y-focus-strong',
            'yoby-a11y-underline-links',
            'yoby-a11y-reduce-motion',
            'yoby-a11y-readable-font'
        );

        if (prefs.contrast) html.classList.add('yoby-a11y-contrast');
        if (prefs.invertColors) html.classList.add('yoby-a11y-invert-colors');
        if (prefs.textSize === 'lg') html.classList.add('yoby-a11y-text-lg');
        if (prefs.textSize === 'xl') html.classList.add('yoby-a11y-text-xl');
        if (prefs.spacing) html.classList.add('yoby-a11y-spacing');
        if (prefs.focusStrong) html.classList.add('yoby-a11y-focus-strong');
        if (prefs.underlineLinks) html.classList.add('yoby-a11y-underline-links');
        if (prefs.reduceMotion) html.classList.add('yoby-a11y-reduce-motion');
        if (prefs.readableFont) html.classList.add('yoby-a11y-readable-font');

        if (modalEl) {
            syncToggleButtons(prefs);
            announcePrefChange(prefs);
        }

        /* Force layout so font-size / filter updates paint before next frame */
        void html.offsetHeight;
    }

    function announcePrefChange(prefs) {
        var live = modalEl && modalEl.querySelector('[data-a11y-live]');
        if (!live) return;
        var parts = OPTIONS.filter(function (opt) { return optionPressed(prefs, opt); }).map(function (opt) {
            return messages().options[OPTIONS.indexOf(opt)][0] + (opt.cycle ? ': ' + optionValueLabel(prefs, opt) : '');
        });
        live.textContent = parts.length
            ? t(9) + parts.join(', ')
            : t(10);
    }

    function optionPressed(prefs, opt) {
        if (opt.cycle) {
            return prefs.textSize !== 'normal';
        }
        return !!prefs[opt.key];
    }

    function optionValueLabel(prefs, opt) {
        if (opt.key === 'textSize') {
            if (prefs.textSize === 'lg') return t(11);
            if (prefs.textSize === 'xl') return t(12);
            return t(13);
        }
        return optionPressed(prefs, opt) ? t(14) : t(15);
    }

    function syncToggleButtons(prefs) {
        modalEl.querySelectorAll('[data-a11y-toggle]').forEach(function (btn) {
            var key = btn.getAttribute('data-a11y-toggle');
            var opt = OPTIONS.filter(function (o) { return o.key === key; })[0];
            if (!opt) return;
            var pressed = optionPressed(prefs, opt);
            btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
            var valEl = btn.querySelector('[data-a11y-value]');
            if (valEl) valEl.textContent = optionValueLabel(prefs, opt);
        });
    }

    function togglePref(key) {
        var prefs = loadPrefs();
        var opt = OPTIONS.filter(function (o) { return o.key === key; })[0];
        if (!opt) return;
        if (opt.cycle) {
            var idx = opt.cycle.indexOf(prefs.textSize);
            if (idx < 0) idx = 0;
            prefs.textSize = opt.cycle[(idx + 1) % opt.cycle.length];
        } else {
            prefs[key] = !prefs[key];
        }
        savePrefs(prefs);
        applyPrefs(prefs);
    }

    function resetPrefs() {
        var prefs = Object.assign({}, DEFAULT_PREFS);
        savePrefs(prefs);
        applyPrefs(prefs);
    }

    function lockScroll(on) {
        try {
            document.documentElement.classList.toggle('yoby-a11y-dialog-lock', !!on);
        } catch (e) {}
    }

    function getFocusables(root) {
        var sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
        return Array.prototype.slice.call(root.querySelectorAll(sel)).filter(function (el) {
            return el.offsetParent !== null || el === document.activeElement;
        });
    }

    function trapFocus(e) {
        if (!modalEl || e.key !== 'Tab') return;
        var focusables = getFocusables(modalEl);
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    function onEscapeKey(e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (!modalEl) return;
        e.preventDefault();
        e.stopPropagation();
        closeModal();
    }

    function closeModal() {
        if (!modalEl) return;
        document.removeEventListener('keydown', onEscapeKey, true);
        document.removeEventListener('keydown', trapFocus, true);
        modalEl.remove();
        modalEl = null;
        lockScroll(false);
        background.forEach(function (el) { el.inert = false; });
        background = [];
        document.querySelectorAll('[data-yoby-a11y-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
        if (prevFocus && prevFocus.focus) {
            try { prevFocus.focus(); } catch (e) {}
        }
        prevFocus = null;
    }

    function buildModal() {
        var wrap = document.createElement('div');
        wrap.id = 'yoby-a11y-modal';
        wrap.className = 'yoby-a11y-dialog yoby-a11y-modal';
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.setAttribute('aria-labelledby', 'yoby-a11y-title');

        var optionsHtml = OPTIONS.map(function (opt, index) {
            var copy = messages().options[index];
            return (
                '<button type="button" class="yoby-a11y-option" data-a11y-toggle="' + opt.key + '" aria-pressed="false">' +
                '  <span><span class="yoby-a11y-option__label">' + copy[0] + '</span>' +
                '  <span class="yoby-a11y-option__hint">' + copy[1] + '</span></span>' +
                '  <span data-a11y-value aria-hidden="true"></span>' +
                '</button>'
            );
        }).join('');

        wrap.innerHTML =
            '<div class="yoby-a11y-dialog__panel" role="document">' +
            '  <div class="yoby-a11y-modal__header">' +
            '    <h2 class="yoby-a11y-dialog__title" id="yoby-a11y-title">' + t(0) + '</h2>' +
            '    <p class="yoby-a11y-modal__intro">' + t(1) + '</p>' +
            '  </div>' +
            '  <div class="yoby-a11y-modal__body">' +
            '    <dl class="yoby-a11y-modal__shortcuts">' +
            '      <dt>' + t(2) + '</dt>' +
            '      <dd><kbd>Alt</kbd>+<kbd>Shift</kbd>+<kbd>A</kbd> (Windows/Linux) · <kbd>⌥ Option</kbd>+<kbd>Shift</kbd>+<kbd>A</kbd> (Mac)</dd>' +
            '      <dt>' + t(3) + '</dt><dd><kbd>Esc</kbd></dd>' +
            '      <dt>' + t(4) + '</dt><dd>' + t(5) + '</dd>' +
            '    </dl>' +
            '    <div class="yoby-a11y-options" role="group" aria-label="' + t(6) + '">' + optionsHtml + '</div>' +
            '    <p class="yoby-a11y-modal__guide"><a href="/accessibility/">' + t(7) + '</a></p>' +
            '    <div class="yoby-visually-hidden" data-a11y-live aria-live="polite" aria-atomic="true"></div>' +
            '  </div>' +
            '  <div class="yoby-a11y-modal__actions">' +
            '    <button type="button" class="yoby-a11y-dialog__btn" data-a11y-reset>' + t(8) + '</button>' +
            '    <button type="button" class="yoby-a11y-dialog__btn yoby-a11y-dialog__btn--danger" data-a11y-close>' + t(3) + '</button>' +
            '  </div>' +
            '</div>';

        wrap.addEventListener('click', function (e) {
            if (e.target === wrap) closeModal();
        });

        wrap.querySelectorAll('[data-a11y-toggle]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                togglePref(btn.getAttribute('data-a11y-toggle'));
            });
        });

        wrap.querySelector('[data-a11y-reset]').addEventListener('click', resetPrefs);
        wrap.querySelector('[data-a11y-close]').addEventListener('click', closeModal);

        return wrap;
    }

    function openModal(focusTrigger) {
        if (modalEl) {
            closeModal();
            return;
        }
        prevFocus = focusTrigger || document.activeElement;
        document.querySelectorAll('[data-yoby-a11y-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
        modalEl = buildModal();
        document.body.appendChild(modalEl);
        lockScroll(true);
        background = Array.prototype.slice.call(document.body.children).filter(function (el) {
            return el !== modalEl && !el.inert && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE';
        });
        background.forEach(function (el) { el.inert = true; });
        applyPrefs(loadPrefs());
        document.addEventListener('keydown', onEscapeKey, true);
        document.addEventListener('keydown', trapFocus, true);
        var first = modalEl.querySelector('[data-a11y-toggle]') || modalEl.querySelector('[data-a11y-close]');
        if (first) first.focus();
    }

    function onGlobalShortcut(e) {
        if (!e.altKey || !e.shiftKey) return;
        if (e.code !== 'KeyA') return;
        if (e.ctrlKey || e.metaKey) return;
        var tag = (e.target && e.target.tagName) || '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        if (e.target && e.target.isContentEditable) return;
        e.preventDefault();
        openModal();
    }

    function init() {
        applyPrefs(loadPrefs());
        function translateTriggers() {
            document.querySelectorAll('[data-yoby-a11y-open]').forEach(function (btn) {
                btn.setAttribute('aria-label', t(0));
                btn.title = t(0) + ' (Alt+Shift+A · ⌥ Option+Shift+A)';
            });
            var skip = document.querySelector('.yoby-skip-link');
            if (skip) skip.textContent = t(16);
        }
        translateTriggers();
        window.addEventListener('yoby:localechange', translateTriggers);
        var skip = document.querySelector('.yoby-skip-link');
        var target = document.querySelector('main') || document.getElementById('yoby-main-content');
        if (skip && target) {
            if (!target.id) target.id = 'yoby-page-content';
            skip.href = '#' + target.id;
            skip.addEventListener('click', function (e) {
                e.preventDefault();
                if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
                target.focus();
                target.scrollIntoView({behavior: 'instant', block: 'start'});
            });
        }
        document.querySelectorAll('[data-yoby-a11y-open]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                openModal(btn);
            });
        });
        document.addEventListener('keydown', onGlobalShortcut, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.YobyA11y = {
        open: function () { openModal(); },
        close: closeModal,
        getPrefs: loadPrefs,
        applyPrefs: applyPrefs
    };
})();
